import { LogoMakerState } from './types';

export const getInitialState = (): LogoMakerState => ({
  loaded: false,
  configuration: {
    mainText: {},
    sloganText: {},
    background: {},
    frame: {},
    logo: {},
    shapeImage: {},
    watermarkImage: {},
  },
});
